import React from 'react';
import ResetButton from '../../../element/resetbutton';
import Title from '../../../element/title';
import url from '../../../urlhandler/urlHandlerActions';

class ResetButtonPreview extends React.Component {
  constructor(props) {
    super(props);
    // this.handlebutton = this.handlebutton.bind(this);
    this.metakey = '_reactive_builder_' + this.props.shortcodeKey;

    this.state = {
      'options': [],
      'toogle': false,
    };
    this.changeToogle = this.changeToogle.bind(this);
    this.handlebutton = this.handlebutton.bind(this);
  }
  componentWillReceiveProps(nextprops) {
    this.setState({ toogle: nextprops.dropdonwtoggle['reset'] });
  }
  changeToogle() {
    const toogle = !this.state.toogle;
    this.setState({ toogle });
  }
  handlebutton() {
    url.push({
      'searchType': 'url_reset',
      'searchField': 'reset',
    });
  }
  render() {
    const ifOpen = this.state.toogle ? 'active' : 'active';
    const scrollBoxClassName = this.props.block.dynamicNameClassScrollBox;
    //const HelperClass = this.state.toogle ? 'single-component' : 'single-component';
    return (<div className={scrollBoxClassName}>

      <div className={'single-component' + ' ' + 'reset-button-stylefix' + ' ' + 'dropdown-template'}>
        <ResetButton isOpenElement={ifOpen} handlebutton={this.handlebutton} buttontitle={this.props.block.buttontitle} buttonstyle={this.props.block.buttonstyle}/>
      </div>
    </div>);
  }
}

ResetButtonPreview.propTypes = {
  'urlData': React.PropTypes.object,
  'block': React.PropTypes.object,
  'shortcodeKey': React.PropTypes.number,
};

export default ResetButtonPreview;



// WEBPACK FOOTER //
// ./assets/src/frontend/preview/search/dropdown/resetbuttondropdownpreview.js